import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import WorriesSection from './components/WorriesSection';
import ReasonsSection from './components/ReasonsSection';
import AreaSection from './components/AreaSection';
import ServicesSection from './components/ServicesSection';
import TestimonialsSection from './components/TestimonialsSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: siteUrl,
      name: '株式会社クリアコーポレーション',
      description: '名古屋16区に強い不動産会社。売却・買取・AI査定（約60秒）を全国対応。',
      inLanguage: 'ja',
    },
    {
      '@type': 'RealEstateAgent',
      '@id': `${siteUrl}/#organization`,
      name: '株式会社クリアコーポレーション',
      url: siteUrl,
      telephone: '052-325-5812',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '江向町五丁目15番地1',
        addressLocality: '名古屋市西区',
        addressRegion: '愛知県',
        postalCode: '451-0013',
        addressCountry: 'JP',
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
          opens: '09:00',
          closes: '17:00',
        },
      ],
      areaServed: '名古屋市全16区・全国',
      description: '名古屋西区に強い不動産会社。名古屋西区をはじめ16区の不動産売却・買取・査定のご相談は株式会社クリアコーポレーションへ。秘密厳守・スピード対応。',
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: siteUrl,
      name: '名古屋不動産売却・買取・査定｜株式会社クリアコーポレーション',
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#organization` },
      description: '名古屋西区に強い不動産会社、株式会社クリアコーポレーション。名古屋西区をはじめ16区の不動産売却・買取・AI査定（約60秒）を全国対応。秘密厳守・スピード対応・宅建免許取得済み。',
      inLanguage: 'ja',
    },
  ],
};

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <title>名古屋西区の不動産売却・買取・AI査定｜株式会社クリアコーポレーション</title>
      <meta name="description" content="名古屋西区に強い不動産会社、株式会社クリアコーポレーション。名古屋西区をはじめ16区の不動産売却・買取・AI査定（約60秒）を全国対応。名古屋西区不動産のご相談は秘密厳守・スピード対応・宅建免許取得済みの当社へ。" />
      <meta name="keywords" content="名古屋西区 不動産, 名古屋西区 不動産売却, 名古屋西区 不動産AI査定, 名古屋西区 不動産買取, 名古屋16区 不動産, クリアコーポレーション" />
      <meta property="og:title" content="名古屋西区の不動産売却・買取・AI査定｜株式会社クリアコーポレーション" />
      <meta property="og:description" content="名古屋西区に強い不動産会社。名古屋西区をはじめ16区の不動産売却・買取・AI査定（約60秒）を全国対応。秘密厳守・スピード対応。" />
      <meta property="og:type" content="website" />
      <link rel="canonical" href="https://clearcorp.info/" />
      <script type="application/ld+json">{JSON.stringify(homeJsonLd)}</script>
      <Header />
      <main>
        <HeroSection />
        <WorriesSection />
        <ReasonsSection />
        <ServicesSection />
        <AreaSection />
        <TestimonialsSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}